/**
 * LoadingScreen - 로딩 화면 컴포넌트
 */

import styles from './LoadingScreen.module.css';

export interface LoadingScreenProps {
  label?: string;
}

export function LoadingScreen({ label = '로딩중...' }: LoadingScreenProps) {
  return (
    <div className={styles.container} role="status" aria-live="polite" aria-busy="true">
      <div className={styles.spinner} />
      <p className={styles.label}>{label}</p>
    </div>
  );
}

export default LoadingScreen;
